"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : EDITABLE TEXT : STYLES --------------- ++++++++++ */


var _default = {
  editabletextwrapper: {
    width: '100%',
    height: function height(props) {
      return props.scrollable === true && props.minHeight ? (0, _index.replacePXinStringWithEM)(props.minHeight) : 'auto';
    },
    minHeight: function minHeight(props) {
      return props.minHeight ? (0, _index.replacePXinStringWithEM)(props.minHeight) : 'auto';
    },
    color: function color(props) {
      return props.textColor ? props.textColor : 'inherit';
    },
    overflow: 'auto',
    '& .editabletext': {
      border: 'none',
      // overflow: 'auto',
      outline: 'none',
      boxShadow: 'none',
      background: 'transparent',
      resize: 'none',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      textAlign: 'inherit',
      color: 'inherit',
      width: '100%',
      height: 'auto',
      transition: 'box-shadow .2s linear 0s',
      overflow: 'hidden',
      whiteSpace: 'normal',
      cursor: 'text',
      '&:empty:not(:focus):before': {
        content: 'attr(data-text)'
      }
    },
    '& .charactercount': {
      position: 'absolute',
      left: '-1px',
      top: '-14px',
      fontSize: '10px',
      fontWeight: 600,
      opacity: 0,
      transition: 'opacity 0.2s linear, color .2s linear',
      '&.limit-approaching': {
        color: '#ffae22'
      },
      '&.limit-reached': {
        color: '#DF1D1B'
      }
    },
    // not supported in IE https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
    '&:focus-within': {
      outlineStyle: 'solid',
      outlineWidth: (0, _index.pxToEm)(1),
      outlineOffset: '0',
      outlineColor: function outlineColor(props) {
        return props.outlineColor ? props.outlineColor : 'inherit';
      },
      '&.valid-false': {
        border: 'none',
        outlineColor: _index.theme.color.warning.dark.swatch
      },
      '& .charactercount': {
        visibility: 'visible',
        opacity: 1
      }
    }
  }
};
exports.default = _default;